import { Component, OnInit, Inject, ElementRef, ViewChild, AfterContentInit, OnChanges, SimpleChanges, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiServicesService } from '../services/api-services.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateBeneComponent } from '../create-bene/create-bene.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import * as Roles from '../../../data/constants/roles';
import { AttorneyService } from 'src/app/services/attorney.service';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, map, filter, takeUntil, take } from 'rxjs/operators';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormGroup } from '@angular/forms';
import { AttorneySendInviteDialogLibraryComponent } from 'projects/attorney-send-invite-dialog-library/src/lib/attorney-send-invite-dialog-library.component';
import { CreateBeneAttorneyComponent } from '../create-bene-attorney/create-bene-attorney.component';
import { SendNotificationComponent } from '../../../modules/beneficiary/profile/send-notification/send-notification.component';
import { PetitionerService } from "src/app/services/petitioner.service";
import { I9EverifyService } from '../../i9-evaluators/i9-everify.service';
import { I9EverificationService } from '../../i9-evaluators/i9-everification.service';
import { NgForm } from '@angular/forms';
import { I9Service } from 'src/app/services/i9-service';
import * as moment from 'moment';
import { CreateNewBeneficiaryComponent } from 'src/app/modules/beneficiary/create-new-beneficiary/create-new-beneficiary.component';
import * as RolesRouteMap from '../../../data/constants/roles';
import { ConfirmationService } from 'primeng/api';
import { InactiveEmployeeDialogComponent } from '../inactive-employee-dialog/inactive-employee-dialog.component';
import { ImagilityBaseResponse, BEN_STATUSES } from 'app-models';
import { environment } from 'src/environments/environment';
import { eVerifyStatuses } from 'src/app/data/constants/e-verify-statuses';
import { SelectionModel } from '@angular/cdk/collections';
import { MigrationConfirmationModalComponent } from '../migration-confirmation-modal/migration-confirmation-modal.component';
import { CustomErrorToastComponent } from 'custom-error-toast';

import { ActivateOrRehireDialogComponent } from '../activate-or-rehire-dialog/activate-or-rehire-dialog.component';

@Component({
    selector: 'app-bene-list',
    templateUrl: './bene-list.component.html',
    styleUrls: ['./bene-list.component.scss'],
    providers: [DialogService]
})
export class BeneListComponent implements OnInit, OnChanges, OnDestroy {

    // allEmployeesData = {
    //     totalAllCount: [],
    //     totalNotIntiatedListCount: [],
    //     totalInProgressListCount: [],
    //     totalCompletedListCount: [],
    //     totalIntiatedListCount: [],
    //     totalSelfListCount: [],
    //     totalAuthRepresentativeListCount: [],
    //     totalVerifyByAgentListCount: [],
    //     totalVideoVerificationListCount: [],

    //     allList: [],
    //     notIntiatedList: [],
    //     intiatedList: [],
    //     completedList: [],
    //     selfList: [],
    //     authRepresentativeList: [],
    //     verifyByAgentList: [],
    //     inProgressList: []
    // };
    allEmployeesData:any;

    isCreateAndEdit = false;
    isCreateAndEditPetition = false;
    beneList: Array<any> = [];
    // displayedColumns: string[] = [];
    dataSource: MatTableDataSource<any>;
    listCompany;
    modalPop = null;
    pageIndex: number;
    pageSize: number;
    searchText: string;
    totalRecordCount: number;
    pageSizeOptions: number[] = [25, 50, 100];
    loggedInUser: any;
    userType: string;
    beneficiaryStatus = 'ACTIVE';
    totalActiveRecords: number;
    totalPastRecords: number;
    totalPendingRecords: number;
    searchSubscription: Subscription;
    taskDetailsSubscription$ = new Subject();
    listOfClientCompanies: any[];
    selectedCompanyId = 0;
    ref: DynamicDialogRef;
    isBeneficiaryAdded: boolean = false;
    observableSubscription$ = new Subject();
    companyIdSelected = 0;
    i9FormStatus: string="ALL";
    i9InprogressFormStatus: string="";
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild('searchBeneficiaryListTable', { static: true }) searchBeneficiaryListTable: ElementRef;
    selection = new SelectionModel<any>(true, []);


    displayedColumns: string[] = ['beneficiaryName', 'email', 'lastDate', 'company', 'source', 'action'];
    displayedColumns2: string[] = ['beneficiaryName', 'email', 'lastDate', 'company', 'source', 'action'];
    
   
    displayedEVerifyColumns:string[] = [];
    eVerificationColumn = [
        { columnDef: 'name', header: 'Employee Name' },
        { columnDef: 'caseNumber', header: 'Case Number' },
        { columnDef: 'startDate', header: 'Employment Start Date' },
        { columnDef: 'endDate', header: 'Previous Empoyment End Date' },
        { columnDef: 'i9InitiatedOn', header: 'Initiated On' },
        { columnDef: 'everifyStatus', header: 'Status' },
        { columnDef: 'action', header: 'Action' }
    ];

    onBoardEmploymentDialogRef: DynamicDialogRef;

    //listInitiateFilter: any = [{ name: 'Initiate', value: 'INITIATED' }, { name: 'Non-Initiate', value: 'NONINITIATED' }];
    //selectedFilterInitiate: any = 'INITIATED';
    I9Form: boolean = false;
    stateList: any = [];
    i9form: any = {};
    beneficiaryProfile: any = {};
    beneficiary_id: any;
    InactivationDate: any;
    activationDate: any;
    totalPetitionApprovedRecords: number;

    isFilter: boolean = false;
    filter: any = { name: '', type: '', companyId: '' };
    _data: any;

    viewEmployeeBy = [
        { label: 'Active Employees', value: 'activeEmployees' },
        { label: 'Inactive Employees', value: 'inActiveEmployees' },
    ];

    employeeViewBy = 'activeEmployees';
    currentTabIndex = 0;
    columns: { columnDef: string; header: string }[] = [];
    currentSubTabIndex = 0;
    initiatedData: any[] = [];
    verifyYourselfData: any[] = [];
    videoVerificationData: any[] = [];
    verificationByEvaluatorData: any[] = [];
    verificationByAuthRepresenativeData: any[] = [];
    inProgressList = [];
    allEmployeeData = [];
    nonInitiatedList=[];
    completedList=[];
    pageIndexEverifications: number;
    pageSizeEverifications: number;
    dataSourceEverifications: MatTableDataSource<any>;
    totalRecordCountEverifications: number;
    displayModal: boolean = false;
    eVerifyUserName:string = '';
    eVerifyPassword:string = '';
    eVerifyLoginPayload = {
        companyId:0,
        beneficiaryEmployeeId:0,
        i9FormId:0,
        i9AdminId:0,
        credential:{
          userName:'',
          passWord:''
        }
      };
    statusModal:boolean = false;
    listOfStatus:any = eVerifyStatuses;
    selectedStatus:string = 'Pending E-Verification';
    caseNumberUpdate;
    companyId:any;
    beneficiaryId:any;
    i9FormId:any;
    selectedOS = 'windows';

    constructor(
        private apiService: ApiServicesService,
        private router: Router,
        private updateEmploymentService: I9EverifyService,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private benapiService: ApiServicesService,
        private toastService: ToastrService,
        private confirmationService: ConfirmationService,
        private attorneyService: AttorneyService,
        private toastr: ToastrService,
        public dialogService: DialogService,
        private petitionerService: PetitionerService,
        private changeDetectorRef: ChangeDetectorRef,
        private i9EverifyService: I9EverifyService,
        private i9Service: I9Service,
        private elementRef: ElementRef,
        private i9EverificationService:I9EverificationService
    ) {
        this.userType = sessionStorage.getItem('userTypeRole');
        this.initColumn();
        this.pageIndex = 0;
        this.pageSize = 50; // default
        this.searchText = '';
        this.pageIndexEverifications = 0;
        this.pageSizeEverifications = 25;
        this.displayedEVerifyColumns = this.eVerificationColumn.map(c => c.columnDef); 
    }
    initColumn() {
       
        if(this.userType !== 'I9Admin')
        {
            this.columns = [
            { columnDef: 'name', header: 'Beneficiary Name' }, 
            { columnDef: 'type', header: 'Type' }, 
            { columnDef: 'relative', header: 'Relative' }, 
            { columnDef: 'companyName', header: 'Company' },
            { columnDef: 'beneficiaryEmail', header: 'Email' },
            { columnDef: 'beneficiaryEmployeePhone', header: 'Phone' },
            { columnDef: 'poc', header: 'POC' },
            { columnDef: 'modeOfCreationName', header: 'Mode of Creation' },
            { columnDef: 'action', header: 'Action'}
          ];
        }

    }

    ngOnInit() {
       

        // 
        this.authenticationService.currentUser.subscribe((data) => {
            if (data) {
                // 
                data.permissions.find(el => {
                    if (el === 'EDIT_BENEFICIARY') {
                        this.isCreateAndEdit = true;
                    }
                });
                data.permissions.find(el => {
                    if (el === 'EDIT_PETITION') {
                        this.isCreateAndEditPetition = true;
                    }
                });
            }
        });

        sessionStorage.setItem('listBeneficiaryId', null);
        this.loggedInUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (this.paginator) {
            this.paginator.pageSize = this.pageSize;
        }
        this.loadBeneficiaryRecordsInit();
        
        this.searchSetUp();
        this.getClientcompanyList();
        this.getStates();
        this.getBeneData();
        this.route.queryParams.subscribe(params => {
            const tab = params['tab'];
            const action = params['action'];

            // Set the tab index based on the query param
            if (tab === 'not-initiated') {
                this.currentTabIndex = 1; // Activate the "Not Initiated" tab
                //this.onTabChange({ index: this.currentTabIndex });
            }

            // Trigger the modal if action is 'create'
            if (action === 'create') {
                this.openFormModalCreate();
            }
        });



    }

    openI9Profile(data) {
        sessionStorage.setItem('beneficiaryId', data.beneficiaryId);
        this.i9Service.getI9BeneficiaryProfile(sessionStorage.getItem('beneficiaryId'))
            .pipe().subscribe((_result: any) => {
                this.i9form.fname = _result.data.firstName;
                this.i9form.mname = _result.data.middleName || '';
                this.i9form.lname = _result.data.lastName;
                var dob = moment(_result.data.dob).format('MM/DD/YYYY');
                this.i9form.dob = new Date(dob);
                this.i9form.email = _result.data.benEmail[0].email || '';
                this.i9form.ssn = _result.data.ssn || '';
                this.i9form.mobile = _result.data.benPhone[0].phoneNo || '';
                this.i9form.address = _result.data.benAddress[0].addressLine1 || '';
                this.i9form.apartment = _result.data.benAddress[0].addressLine2 || '';
                this.i9form.city = _result.data.benAddress[0].city || '';
                this.i9form.stateProvinceName = _result.data.benAddress[0].stateProvinceName || '';
                this.i9form.stateProvinceCode = _result.data.benAddress[0].stateProvinceCode || '';
                this.i9form.zipcode = _result.data.benAddress[0].postCode || '';
                this.i9form.empStartDate = _result.data.empStartDate || '';
                this.i9form.empEndDate = _result.data.empEndDate || '';
            })
        this.I9Form = true;
    }

    getStates() {
        this.petitionerService.getStates().pipe(takeUntil(this.observableSubscription$))
            .subscribe((response: any[]) => {
                this.stateList = response;
            })
    }

    getClientcompanyList() {
        this.petitionerService.getPetitionerClientList(parseInt(sessionStorage.getItem('companyId')))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response: any[]) => {
                let options = [];
                response.forEach(ele => {
                    options.push({ 'petitionerId': ele['id'], 'petitionerName': ele['companyName'] })
                });
                this.listOfClientCompanies = options;
                this.selectedCompanyId = this.companyIdSelected != 0 ? this.companyIdSelected : this.listOfClientCompanies[0].petitionerId;
                this.handleCompanyChange();
            });
    }

    deLinkBeneficiary(row) {
        this.confirmationService.confirm({
          message: 'Are you sure you want to delete beneficiary?',
          header: 'Delete Beneficiary',
          accept: () => {
            this.apiService.delinkBeneficiary(row.beneficiaryEmployeeId, row.companyId)
              .pipe(take(1))
              .subscribe(result => {
                if (result.status === 200) {
                  this.toastService.success(result.message, 'Success');
                  this.handleCompanyChange();
                  this.loadBeneficiaryRecordsInit();
                }
              });
          },
          reject: () => {
          }
        });
      }

    sendInviteBeneficiary(row) {
        const ref = this.dialogService.open(AttorneySendInviteDialogLibraryComponent, {
            header: 'Send Invite',
            width: '60%',
            data: {
                companyName: row.companyName,
                companyId: row.companyId,
                beneficiaryId: row?.beneficiaryId || row?.beneficiaryEmployeeId,
                emailId: row.beneficiaryEmail,
                name: `${row.beneficiaryEmployeeFName} ${row.beneficiaryEmployeeMName && row.beneficiaryEmployeeMName.trim() !== '' ? row.beneficiaryEmployeeMName : ''} ${row.beneficiaryEmployeeLName}`
            },
            styleClass: 'attorney-invite-emp-bene'
        });
    }


    searchSetUp() {
        this.searchSubscription = fromEvent(this.searchBeneficiaryListTable.nativeElement, 'keyup').pipe(
            map((event: any) => event.target.value)
            , filter(res => !res || (res && (res.length > 2 || res.length === 0)))
            , debounceTime(1000)).subscribe((text: string) => {
                if (this.dataSource && this.dataSource.paginator) {
                    this.dataSource.paginator.firstPage();
                }
                this.searchText = text.trim();
                this.loadBeneficiaryRecordsInit();
                this.handleCompanyChange();
            });
    }

    loadBeneficiaryRecordsInit() {
        try {
            const payload = {
                pageNumber: this.pageIndex + 1,
                pageSize: this.pageSize,
                // searchCriteria: '',
                searchText: this.searchText,
                employeeStatus: this.employeeViewBy == 'activeEmployees' ? 'ACTIVE' : 'INAC',
                i9FormStatus:this.i9FormStatus,
                i9InprogressFormStatus:this.i9InprogressFormStatus
                // sortBy: 'beneficiaryName',
                // sortOrder: 'asc',
            };
            if (this.loggedInUser.userType === Roles.ATTORNEY) {
                this.getbeneficiaryListForAttorney(payload);
            }
            else if (this.loggedInUser.userType === Roles.I9ADMIN) {
               // if (this.employeeViewBy == 'activeEmployees') {
                    this.getEmployeesData(payload);
                    this.getRemoteI9Verifications();
               // } else {
                  //  this.getInactiveEmployeeList(payload);
               // }
            } else {
                this.getbeneficiaryListForPetitioner(payload);
            }
        } catch (error) {
            console.log(error);
        }
    }

    // ngAfterContentInit() {
    //     if(this.userType!=='I9Admin')
    //     {
    //     this.displayedColumns = this.columns.map(c => c.columnDef);
    //     }
    // }

    ngOnChanges(e: SimpleChanges) {
        
        if (e.listCompany && e.listCompany.currentValue) {
            this.dataSource = new MatTableDataSource(e.listCompany.currentValue);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    openPetitionBuilder(row) {
        sessionStorage.setItem('listBeneficiaryId', row.beneficiaryId);
        this.router.navigate(['/petitioner-landing/builder/petition-builder'], { relativeTo: this.route });
    }

    // IM-3352 (IM-3335) user story
    openFormModal(inviteType, row?) {
        const modalRef = this.modalService.open(CreateBeneComponent, { size: 'lg', backdrop: 'static', keyboard: false });
        modalRef.componentInstance.company = this.listCompany;
        if (inviteType === 'SEND INVITE' && row) {
            modalRef.componentInstance.beneficiary = row;
        }
        modalRef.componentInstance.refreshList
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe((result) => {
                if (result === 'Success') {
                    this.loadBeneficiaryRecordsInit();
                }
            });

    }

    openInitiateI9(row) {
        const queryParamsObj = {
            companyId: row.companyId || 0,
            beneficiaryEmployeeId: row.beneficiaryId || 0,
            beneficiaryEmployeeFName: row.beneficiaryEmployeeFName || 'Not Available',
            beneficiaryEmail: row.email || 'Not Available',
            companyName: row.companyName || 'Not Available',
            row: row,
            i9FormId: row.i9FormId,
            email: row.email,
            confirmationSent: row?.confirmationSent,
            i9StatusCode: row?.i9StatusCode,
            meetingStatus: null,
            meetingId: null,
            lastConfirmationAdmin: row?.lastConfirmationAdmin,
            lastConfirmationDate: row?.lastConfirmationDate,
            lastConfirmationTime: row?.lastConfirmationTime
        }
        if (row.meetingStatus == 'MEETSCHDL') {
            queryParamsObj.meetingStatus = row.meetingStatus;
            queryParamsObj.meetingId = row.meetingId;
        }
        this.router.navigate(['../../i9-evaluators/evaluation-request'], { queryParams: queryParamsObj, relativeTo: this.route });
    }

    openUpdateEmployment(row, updateEmploymentType) {
        const queryParamsObj = {
          beneficiaryEmployeeId: row.beneficiaryEmployeeId || 0,
          companyId: row.companyId || 0,
          taskId: 0,
          i9FormId: row.i9FormId || 0
        };
        if (updateEmploymentType === 'start') {
          if (row?.isEmploymentUpdatable) {
            this.router.navigate(['../update-employment/on-board'], { queryParams: queryParamsObj, relativeTo: this.route });
          } else {
            CustomErrorToastComponent.showErrorToast(this.toastr, row?.updateEmploymentError);
          }
        } else {
          if (row?.i9FormId) {
            this.router.navigate(['../update-employment/I-9'], { queryParams: queryParamsObj, relativeTo: this.route });
          } else {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'I9 is yet to be intitiated. Please try again, after initiating the I9.');
          }
    
        }
    
      }

      openBeneProfileDetails(row, viewPetitions: boolean = false, viewLCA?: boolean) {
        const customSelectedCompanyId: any = this.selectedCompanyId;
        localStorage.setItem('cutomSelectedCompanyId', customSelectedCompanyId);
        sessionStorage.setItem('listBeneficiaryId', row.beneficiaryEmployeeId);
        sessionStorage.setItem('beneficiaryId', row.beneficiaryEmployeeId);
        sessionStorage.removeItem('bene-update-profile');
        if(row?.isApplicant){
          sessionStorage.setItem('navigationFamilySection', 'true');
          sessionStorage.setItem('relationshipCode', row.relative.toUpperCase());
          sessionStorage.setItem('relativeId', row.applicantFamilyId);
        }else{
          sessionStorage.removeItem('navigationFamilySection');
          sessionStorage.removeItem('relationshipCode');
          sessionStorage.removeItem('relativeId');
        }
        if(viewPetitions){
          sessionStorage.setItem('viewPetitions', 'true');
        }else{
          sessionStorage.removeItem('viewPetitions');
        }
        if (viewLCA) {
          sessionStorage.setItem('viewLCA', 'true');
        } else {
          sessionStorage.removeItem('viewLCA');
        }
        // IM-3898
        this.router.navigate(['../../beneficiaries/profile/profile-details'], { state: { profileName: row.beneficiaryEmployeeFName + '\'s profile', redirectUrl: '../list', redirectPage: 'Back to beneficiary List' }, relativeTo: this.route });
      }
      

    resendBeneficiaryInvite(row) {
        this.apiService.resendBenificaryInvite(parseInt(row.linkRequestId))
          .pipe(takeUntil(this.taskDetailsSubscription$))
          .subscribe((result: any) => {
            if (result) {
              this.toastr.success(result.message, 'Success');
              this.loadBeneficiaryRecordsInit();
            }
            else {
              CustomErrorToastComponent.showErrorToast(this.toastr, result.message);
            }
          });
      }

      withDrawnBeneficiaryInvite(row) {
        this.apiService.withdrawanBenificaryInvite(parseInt(row.linkRequestId))
          .pipe(takeUntil(this.taskDetailsSubscription$))
          .subscribe((result: any) => {
            if (result) {
              this.toastr.success(result.message, 'Success');
              this.loadBeneficiaryRecordsInit();
            }
            else {
              CustomErrorToastComponent.showErrorToast(this.toastr, result.message);
            }
          });
      }

    paginationEvent(event: PageEvent) {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadBeneficiaryRecordsInit();
    }

    paginationEventEverifications(event: PageEvent) {
        this.pageSizeEverifications = event.pageSize;
        this.pageIndexEverifications = event.pageIndex;
        this.getRemoteI9Verifications();
    }


    getBeneficiaryWithStatus(ststusVal: string) {
        if (ststusVal && this.userType !== 'I9Admin') {

            if (this.userType == 'I9Admin') {
                if (ststusVal == 'ACTIVE') {
                    this.pageIndex = 0;
                    this.loadBeneficiaryRecordsInit();
                } else {
                    this.dataSource = new MatTableDataSource([]);
                }
            }
            else {
                this.beneficiaryStatus = ststusVal;
                if (this.beneficiaryStatus !== 'ACTIVE') {
                    this.displayedColumns2 = ['name', 'companyName', 'action'];
                }
                else {
                    this.displayedColumns = ['name', 'companyName', 'modeOfCreationName', 'action'];
                }
                this.pageIndex = 0;
                this.loadBeneficiaryRecordsInit();
            }
        }
    }

    getbeneficiaryListForPetitioner(payload) {
        let companyid = this.selectedCompanyId;
        if (!companyid) {
          companyid = parseInt(sessionStorage.getItem('companyId'));
        }
        let statusColumnDef = {columnDef: 'status', header: 'Status'};
        payload.status = [`${this.beneficiaryStatus}`];
        // Need to integrate API once ready
        if (this.beneficiaryStatus === 'PETITION_APPROVED') {
          // Setting the columns
          if (!this.columns.some(e => e.columnDef === 'status')) {
            this.columns.splice(this.columns.length - 1, 0, statusColumnDef);
            this.displayedColumns = this.columns.map(c => c.columnDef);
            this.displayedColumns.unshift('select');
            this.changeDetectorRef.detectChanges();
          }
          payload.status = ['ACTIVE'];
          this.apiService.getBeneficiariesListForApprovedPetitions(companyid, payload)
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
              if (result) {
                const beneList = result.beneficiaryList;
                beneList.forEach((item) => {
                  item.name = `${item.beneficiaryEmployeeFName} ${item.beneficiaryEmployeeMName || ''} ${item.beneficiaryEmployeeLName}`;
                });
                this.dataSource = new MatTableDataSource(beneList);
                this.totalPetitionApprovedRecords = result.beneficiaryList.length;
                this.totalRecordCount = result.beneficiaryList.length;
              } else {
                // Handling null scenario
                this.totalPetitionApprovedRecords = 0;
                this.totalRecordCount = 0;
                this.dataSource = new MatTableDataSource([]);
              }
            })
        } else {
          //payload.status = BEN_STATUSES[`${this.beneficiaryStatus}`];          
          this.columns = this.columns.filter(obj => obj.columnDef !== 'status' );
          this.displayedColumns = this.columns.map(c => c.columnDef);
          this.apiService.getBeneficiariesListForPetitioner(companyid, payload)
          .pipe(takeUntil(this.taskDetailsSubscription$))
          .subscribe(result => {
            if (result) {
              const beneList = result.beneficiaryList;
              beneList.forEach(item => {
                item.name = `${item.beneficiaryEmployeeFName} ${item.beneficiaryEmployeeMName || ''} ${item.beneficiaryEmployeeLName}`;
              });
    
              this.totalRecordCount = this.beneficiaryStatus === 'ACTIVE' ?
                result.totalActiveRecords :
                (this.beneficiaryStatus === 'PEND' ? result.totalPendingRecords : result.totalPastRecords);
              this.totalActiveRecords = result.totalActiveRecords ? result.totalActiveRecords : 0;
              this.totalPastRecords = result.totalPastRecords ? result.totalPastRecords : 0;
              this.totalPendingRecords = result.totalPendingRecords ? result.totalPendingRecords : 0;
              this.dataSource = new MatTableDataSource(beneList);
    
            } else {
              this.totalRecordCount = 0;
              this.totalActiveRecords = 0;
              this.totalPastRecords = 0;
              this.totalPendingRecords = 0;
              this.dataSource = new MatTableDataSource([]);
            }
          });
        }
      }

      getbeneficiaryListForAttorney(payload) {

        this.attorneyService.getBeneficiariesListForAttorney(parseInt(sessionStorage.getItem('companyId')), payload)
          .pipe(takeUntil(this.taskDetailsSubscription$))
          .subscribe((result: any) => {
            if (result) {
              const beneList = result.beneficiaryList;
              beneList.forEach((item: any) => {
                item.name = `${item.beneficiaryEmployeeFName} ${item.beneficiaryEmployeeMName} ${item.beneficiaryEmployeeLName}`;
                item.beneficiaryEmployeeId = item.id;
              });
              this.totalRecordCount = this.beneficiaryStatus === 'ACTIVE' ?
                result.totalActiveRecords :
                (this.beneficiaryStatus === 'PEND' ? result.totalPendingRecords : result.totalPastRecords);
              this.totalActiveRecords = result.totalActiveRecords ? result.totalActiveRecords : 0;
              this.totalPastRecords = result.totalPastRecords ? result.totalPastRecords : 0;
              this.totalPendingRecords = result.totalPendingRecords ? result.totalPendingRecords : 0;
              this.dataSource = new MatTableDataSource(beneList);
            }
            else {
              this.totalRecordCount = 0;
              this.dataSource = new MatTableDataSource([]);
            }
          });
      }
    resetSearch() {
        this.searchText = ''; // reset search
        this.pageIndex = 0; // reset search
        this.loadBeneficiaryRecordsInit();
    }

    requestDataDocuments(elem) {
        sessionStorage.setItem('tempBeneficiaryEmployeeId', elem.beneficiaryId);
        this.router.navigate(['../request-data'], { queryParams: elem, relativeTo: this.route });
    }
  
  
    initiateCaseRequest(elem) {
        sessionStorage.setItem('caseBenDetails', JSON.stringify(elem));
        this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/case-request/create-request-initiate`]);

    }

    backToDashboard() {
        this.router.navigate(['petitioner-landing/dashboard/petitioner-dashboard']);
    }

    formatDateToISO(dateString: Date): string {
        return moment(dateString).format('YYYY-MM-DD');
    }

    isValidDate(dateString: string): boolean {
        if (dateString) {
            const date = new Date(dateString);
            return !isNaN(date.getTime());
        }
        return false;
    }

    formatDateToMMDDYYYY(dateString: string): any {
        //return this.datePipe.transform(new Date(dateString), 'yyyy-MM-ddThh:mm:ss.SSSZ')
        if (dateString) {
            return moment(dateString).utcOffset(0, false).toLocaleString();
        }
        return null;
    }

    activateOrRehire(row, status) {
            const dialogRef = this.dialog.open(ActivateOrRehireDialogComponent, {
                width: '840px',
                data: { employee: row, status: status },
            });
            dialogRef.afterClosed().subscribe((val) => {
                let companyid = this.selectedCompanyId;
                if (!companyid) {
                    companyid = parseInt(sessionStorage.getItem('companyId'));
                }
                if(val) {
                    this.InactivationDate = moment(val.date).format('YYYY-MM-DD');
                    const payload = {
                        beneficiaryId: row.beneficiaryId,
                        companyId: companyid,
                        isActive: status,
                        lastDate: this.isValidDate(this.InactivationDate) ? this.InactivationDate : ''
                    };
                    this.petitionerService.updateEmployeeStatus(payload)
                        .pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                            this.toastService.success(response.message);
                            this.loadBeneficiaryRecordsInit();
                            if (val.rehireActivation) {
                              this.updateEmployment(row);
                            }
                        });
                }
                else {
                    this.loadBeneficiaryRecordsInit();
                }
            });
    }

    updateEmployment(beneficiary) {
      let payload = {
        beneficiaryId: beneficiary.beneficiaryId,
        comments: null,
        employmentEndDate: null,
        employmentStartDate: null,
        rehireDate: this.InactivationDate,
        taskId: 0,
        companyId: beneficiary.companyId,
        isBenNotifyLcaLinkPet: true,
        initiateI9Form: beneficiary.i9FormId ? false : true,
        i9FormId: beneficiary.i9FormId,
        companyName: beneficiary.companyName,
        beneficiaryEmployeeFName: beneficiary.beneficiaryName,
        beneficiaryEmail: beneficiary.email
      }
      this.updateEmploymentService.updateEmployment(payload).subscribe(
        (val) => {
            this.editPastDoc(beneficiary);
        }
      )
    }

    inactivateEmployee(row, status) {
        if (status != false) {
            const dialogRef = this.dialog.open(InactiveEmployeeDialogComponent, {
                width: '300px',
                data: { employee: row, status: status },
            });
            dialogRef.afterClosed().subscribe((selectedDate) => {
                let companyid = this.selectedCompanyId;
                if (!companyid) {
                    companyid = parseInt(sessionStorage.getItem('companyId'));
                }
                if (selectedDate) {
                    this.InactivationDate = moment(selectedDate).format('YYYY-MM-DD');
                    const payload = {
                        beneficiaryId: row.beneficiaryId,
                        companyId: companyid,
                        isActive: status,
                        lastDate: this.isValidDate(this.InactivationDate) ? this.InactivationDate : ''
                    };
                    this.petitionerService.updateEmployeeStatus(payload)
                        .pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                            this.toastService.success(response.message);
                            this.loadBeneficiaryRecordsInit();
                        });
                }
                else {
                    this.loadBeneficiaryRecordsInit();
                }
            });
        }
        else {
            const dialogRef = this.dialog.open(InactiveEmployeeDialogComponent, {
                width: '300px',
                data: { employee: row, status: status },
            });
            dialogRef.afterClosed().subscribe((selectedDate) => {
                let companyid = this.selectedCompanyId;
                if (!companyid) {
                    companyid = parseInt(sessionStorage.getItem('companyId'));
                }
                if (selectedDate) {
                    this.activationDate = moment(selectedDate).format('YYYY-MM-DD');
                    const payload = {
                        beneficiaryId: row.beneficiaryId,
                        companyId: companyid,
                        isActive: status,
                        lastDate: this.isValidDate(this.activationDate) ? this.activationDate : ''
                    };
                    this.petitionerService.updateEmployeeStatus(payload)
                        .pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                            this.toastService.success(response.message);
                            this.loadBeneficiaryRecordsInit();
                        });
                }
                else {
                    this.loadBeneficiaryRecordsInit();
                }
            });
        }
    }

    // inactivateEmployee(row, status) {
    //     let companyid = this.selectedCompanyId;
    //     if (!companyid) {
    //         companyid = parseInt(sessionStorage.getItem('companyId'));
    //     }
    //     this.petitionerService.updateEmployeeStatus(payload)
    //         .pipe(takeUntil(this.observableSubscription$))
    //         .subscribe((response) => {
    //             this.toastService.success(response.message);
    //             this.loadBeneficiaryRecordsInit();
    //         });
    // }
    viewOrEditEmployee(row) {
        this.openFormModalCreate(row);
    }

    ngOnDestroy() {
        localStorage.removeItem('cutomSelectedCompanyId');
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
        if (this.onBoardEmploymentDialogRef) {
            this.onBoardEmploymentDialogRef.close();
        }
        if (this.ref) {
            this.ref.close();
        }

    }

    updateInfo(row, type) {
        const dialogRef = this.dialog.open(UpdateInfoDialogComponent, {
            width: '500px',
            maxHeight: '600px',
            hasBackdrop: false,
            data: {
                beneficiary: row,
                type
            }
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
                this.loadBeneficiaryRecordsInit();
            });
    }

    // new functions
    openBenefiary() {
        this.router.navigateByUrl('petitioner-landing/beneficiaries/beneficiary-invite');
    }

    openFormModalCreate(row = null) {
        let action = row ? 'Update Employee' : 'Create Employee';
        this.ref = this.dialogService.open(CreateNewBeneficiaryComponent, {
            header: this.userType == 'Beneficiary' ? 'Create Beneficiary' : action,
            width: '70%',
            contentStyle: { 'max-height': '800px', overflow: 'auto' },
            data: row,
        });
        this.ref.onClose.subscribe((result) => {
            if (result) {
                this.loadBeneficiaryRecordsInit();
            }
        });
    }

    handleCompanyChange() {
        this.loadBeneficiaryRecordsInit();
    }

    // handleInitiateBy(event) {
    //     this.selectedFilterInitiate = event.value;
    //     this.loadBeneficiaryRecordsInit()
    // }

    sendInvite() {
        this.ref = this.dialogService.open(CreateBeneAttorneyComponent, {
            header: 'Invite Beneficiary',
            width: '50%',
            contentStyle: { 'max-height': '500px', overflow: 'auto' }
        });
    }

    onClickNotifyBeneficiary() {
        const dialogRef = this.dialog.open(SendNotificationComponent, {
            data: parseInt(sessionStorage.getItem('companyId')),
            panelClass: 'custom-dialog',
            width: '600px'
        });

    }

    getBeneData() {
        this.beneficiaryProfile = {
            "id": Number,
            "fName": "",
            "mName": "",
            "lName": "",
            "title": null,
            "aliasName": null,
            "gender": null,
            "dob": "",
            "ssn": "",
            "emailContacts": [
                {
                    "email": "",
                    "type": {
                        "code": "PRIM",
                        "id": 34
                    }
                }
            ],
            "phoneContacts": [
                {
                    "phoneNo": "",
                    "type": {
                        "code": "MOBL",
                        "id": 31
                    },
                    "countryCode": {
                        "countryCode": "",
                        "phoneCode": ""
                    }
                }
            ],
            "address": [
                {
                    "addressLine1": "",
                    "addressLine2": "",
                    "postCode": "",
                    "doorNo": "",
                    "streetNo": "",
                    "countryCode": {
                        "countryCode": "USA"
                    },
                    "stateProvinceCode": "",
                    "stateProvinceName": "",
                    "city": "",
                    "locality": "",
                    "type": {
                        "id": 1,
                        "code": "CURR"
                    }
                }
            ],

            "hasPassport": false,
            "passport": null,
            "currentVisaStatus": null,
            "profileImage": null,
            "smallProfileImage": null,
            "profilePic": null,
            "smallProfilePic": null,
            "firstAndLastName": "",
            "maritalStatus": null,
            "countryOfMarriage": null,
            "marriageStateProvinceCode": null,
            "marriageStateProvinceName": null,
            "cityOfMarriage": null,
            "isLpr": 0,
            "lprThruMarriage": 0,
            "greenCardNo": null,
            "ethnicity": null,
            "race": null,
            "weight": null,
            "ctznAcqrTypeId": null,
            "hasCtznCrtfct": 0,
            "ctznCrtfctNo": null,
            "ctznCrtfctIssPlace": null,
            "ctznCrtfctIssDate": null,
            "marriageDate": null,
            "birthCountryCode": null,
            "isSaveAsDraft": false
        }
    }

    profileSateChange(event, value) {
        var stateName = event.originalEvent.srcElement.innerText;
        this.i9form.stateProvinceCode = event.value;
        this.i9form.stateProvinceName = stateName;
    }

    i9FormSubmit(form: NgForm) {
        if (!form.valid) {
            return;
        }


        this.beneficiaryProfile.fName = this.i9form.fname;
        this.beneficiaryProfile.mName = this.i9form.mname || '';
        this.beneficiaryProfile.lName = this.i9form.lname;
        this.beneficiaryProfile.dob = this.i9form.dob;
        this.beneficiaryProfile.phoneContacts[0].phoneNo = this.i9form.mobile;
        this.beneficiaryProfile.emailContacts[0].email = this.i9form.email;
        this.beneficiaryProfile.address[0].addressLine1 = this.i9form.address;
        this.beneficiaryProfile.address[0].addressLine2 = this.i9form.apartment || '';
        this.beneficiaryProfile.address[0].city = this.i9form.city;

        this.beneficiaryProfile.address[0].stateProvinceCode = this.i9form.stateProvinceCode;
        this.beneficiaryProfile.address[0].stateProvinceName = this.i9form.stateProvinceName;

        this.beneficiaryProfile.address[0].postCode = this.i9form.zipcode;
        this.beneficiaryProfile.ssn = this.i9form.ssn || '';
        this.beneficiaryProfile.empStartDate = this.i9form.empStartDate || '';
        this.beneficiaryProfile.empEndDate = this.i9form.empEndDate || '';
        this.beneficiary_id = sessionStorage.getItem('beneficiaryId');

        this.i9Service.i9FormFilling(this.beneficiary_id, this.beneficiaryProfile).pipe().subscribe((result: any) => {

            this.I9Form = false;
            this.toastr.success(result.message);
        })

    }

    editPastDoc(row) {
        if (row.i9StatusCode == 'COMPLTD') {
            const queryParamsObj = {
                companyId: row.companyId || 0,
                beneficiaryEmployeeId: row.beneficiaryId || 0,
                beneficiaryEmployeeFName: row.beneficiaryEmployeeFName || 'Not Available',
                beneficiaryEmail: row.beneficiaryEmail || 'Not Available',
                employeeFname: row.beneficiaryEmployeeFName || 'Not Available',
                employeeLname: row.beneficiaryEmployeeLName ? row.beneficiaryEmployeeLName : '',
                i9FormId: row.i9FormId ? row.i9FormId : null,
                empType: row.comments == 'BULKUPLOAD' ? 'BULKUPLOAD' : 'CREATED',
                i9Status: row.i9StatusCode ? row.i9StatusCode : ''
            }
            if(row?.beneficiaryName){
                queryParamsObj['benEmployeeName'] = row?.beneficiaryName;
            }
            this.router.navigate(['../../i9-evaluators/bulk-upload-view'], { queryParams: queryParamsObj, relativeTo: this.route });
        } else {
            this.openInitiateI9(row);
        }
    }

    confirmPastDocDelete(item) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete?',
            key: 'deletePastDoc',
            accept: () => {
                this.deleteI9PastDoc(item);
            },
            reject: () => {
            }
        });
    }

    deleteI9PastDoc(item) {
        let companyid = this.selectedCompanyId;
        if (!companyid) {
            companyid = parseInt(sessionStorage.getItem('companyId'));
        }
        this.petitionerService.deleteEmployee(item.beneficiaryId, companyid)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
                this.loadBeneficiaryRecordsInit();
                this.toastService.success(response.message);
            });
    }

    filterOpen() {
        this.isFilter = !this.isFilter;
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isFilter = false;
        }
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscPress(event: KeyboardEvent) {
        this.isFilter = false;
    }

    closeFilter() {
        this.isFilter = false;
    }

    stopPropagation(event: Event) {
        event.stopPropagation();
    }

    filterAction() {
        this.filter.companyId = parseInt(sessionStorage.getItem('companyId'));
        this.apiService.searcFilterNewUI(this.filter).subscribe(res => {
            this._data = res;
            const beneList = this._data.data.beneficiaryList;


            beneList.forEach(item => {
                item.name = `${item.beneficiaryEmployeeFName} ${item.beneficiaryEmployeeMName || ''} ${item.beneficiaryEmployeeLName}`;

            });

            this.totalRecordCount = this.beneficiaryStatus === 'ACTIVE' ?
                this._data.data.totalActiveRecords :
                (this.beneficiaryStatus === 'PEND' ? this._data.data.totalPendingRecords : this._data.data.totalPastRecords);

            this.dataSource = beneList;
        });
        this.filter = { name: '', type: '', companyId: '' };
        this.isFilter = false;
    }

    gridView() {
        this.router.navigate(['../list-grid'], { relativeTo: this.route });
    }
    async getEmployeesData(payload) {
        let companyid = this.selectedCompanyId;
        if (!companyid) {
            companyid = parseInt(sessionStorage.getItem('companyId'));
        }
        this.apiService.getEmployeesListForI9Admin(companyid, payload)
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
                if (result) {
                    this.allEmployeesData = result;
                    if (this.employeeViewBy == 'activeEmployees'){
                        if(this.i9FormStatus=="ALL") {
                            this.dataSource = new MatTableDataSource(this.allEmployeesData.allList);
                        }
                        else if(this.i9FormStatus=="NOTINITIATED") {
                            this.dataSource = new MatTableDataSource(this.allEmployeesData.notIntiatedList);
                        }
                        else if(this.i9FormStatus=="INPROGRESS") {
                            if(this.i9InprogressFormStatus=="INITIATED") {
                                this.dataSource = new MatTableDataSource(this.allEmployeesData.intiatedList);
                            }
                            else if(this.i9InprogressFormStatus=="ALL") {
                                this.dataSource = new MatTableDataSource(this.allEmployeesData.intiatedList);
                            }
                            else if(this.i9InprogressFormStatus=="SELF") {
                                    this.dataSource = new MatTableDataSource(this.allEmployeesData.selfList);
                            }
                            else if(this.i9InprogressFormStatus=="videoVerification") {
                                this.dataSource = new MatTableDataSource(this.allEmployeesData.videoVerificationList);  
                            }
                            else if(this.i9InprogressFormStatus=="verifyByAgent") {
                                this.dataSource = new MatTableDataSource(this.allEmployeesData.verifyByAgentList);  
                            }
                            else if(this.i9InprogressFormStatus=="authRepresentative") {
                                this.dataSource = new MatTableDataSource(this.allEmployeesData.verificationByAuthRepresenativeData);         
                            }
                        }
                        else if(this.i9FormStatus=="COMPLETED") {
                            this.dataSource = new MatTableDataSource(this.allEmployeesData.completedList);
                        }
                    }
                    else {
                        this.dataSource = new MatTableDataSource(this.allEmployeesData.inactiveEmployeesList); 
                    }
                    
                } else {
                    this.dataSource = new MatTableDataSource([]);
                }
            
            });
            

    }

    onTabChange(event: any): void {
        this.currentTabIndex = event.index;
        this.pageIndex = 0;
        switch (this.currentTabIndex) {
            case 0:
                this.i9FormStatus="ALL";
                this.i9InprogressFormStatus="";
                this.loadBeneficiaryRecordsInit();
                break;
            case 1:
                this.i9FormStatus="NOTINITIATED";
                this.i9InprogressFormStatus="";
                this.loadBeneficiaryRecordsInit();   
                break;
            case 2:
                this.i9FormStatus="INPROGRESS";
                const obj = {
                    index: this.currentSubTabIndex
                }
                this.onInProgressTabChange(obj);
                break;
            case 3:
                this.i9FormStatus="COMPLETED";
                this.i9InprogressFormStatus="";
                this.loadBeneficiaryRecordsInit();
                break;
        }
      
    }


    onInProgressTabChange(event: any): void {
        this.currentSubTabIndex = event.index;
        this.mapInProgressData();
        switch (event.index) {
            case 0:
                this.i9InprogressFormStatus="INITIATED";
                this.loadBeneficiaryRecordsInit();
                break;
            case 1:
                this.i9InprogressFormStatus="INITIATED";
                this.loadBeneficiaryRecordsInit();
                break;
            case 2:
                this.i9InprogressFormStatus="SELF";
                this.loadBeneficiaryRecordsInit();
                break;
            case 3:
                this.i9InprogressFormStatus="videoVerification";
                this.loadBeneficiaryRecordsInit();
                break;
            case 4:
                this.i9InprogressFormStatus="verifyByAgent";
                this.loadBeneficiaryRecordsInit();
                break;
            case 5:
                this.i9InprogressFormStatus="authRepresentative";
                this.loadBeneficiaryRecordsInit();
                break;
            case 6:
                this.i9InprogressFormStatus="eVerificationRecords";
                this.getRemoteI9Verifications();
                break;
        }
    }

    viewEmployeeByChange() {
        this.searchText = '';
        this.loadBeneficiaryRecordsInit();
    }
    getInactiveEmployeeList(payload) {
        let companyid = this.selectedCompanyId;
        if (!companyid) {
            companyid = parseInt(sessionStorage.getItem('companyId'));
        }
        this.apiService.getInactiveEmployeesListForI9Admin(companyid, payload)
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
                if (result) {
                    this.dataSource = new MatTableDataSource(result.dtoList);
                } else {
                    this.dataSource = new MatTableDataSource([]);
                }
            });
    }
    mapInProgressData() {
        if (this.employeeViewBy == 'activeEmployees'){// this.allEmployeeData.filter(item => item.active === 'ACTIVE');
            this.initiatedData = this.allEmployeesData?.intiatedList ? this.allEmployeesData.intiatedList.filter(item => item.active === 'ACTIVE'):[];
            this.verifyYourselfData = this.allEmployeesData?.selfList ? this.allEmployeesData.selfList.filter(item => item.active === 'ACTIVE') :[];
            this.videoVerificationData = this.allEmployeesData?.inProgressList ? this.allEmployeesData.inProgressList.filter(item => item.active === 'ACTIVE'):[];
            this.verificationByEvaluatorData = this.allEmployeesData?.verifyByAgentList ? this.allEmployeesData.verifyByAgentList.filter(item => item.active === 'ACTIVE') :[];
            this.verificationByAuthRepresenativeData = this.allEmployeesData?.authRepresentativeList ? this.allEmployeesData.authRepresentativeList.filter(item => item.active === 'ACTIVE') :[];
        }
        else{
            this.initiatedData = this.allEmployeesData?.intiatedList ? this.allEmployeesData.intiatedList.filter(item => item.active === 'INAC'):[];
            this.verifyYourselfData = this.allEmployeesData?.selfList ? this.allEmployeesData.selfList.filter(item => item.active === 'INAC'): [];
            this.videoVerificationData = this.allEmployeesData?.inProgressList ? this.allEmployeesData.inProgressList.filter(item => item.active === 'INAC'):[];
            this.verificationByEvaluatorData = this.allEmployeesData?.verifyByAgentList ? this.allEmployeesData.verifyByAgentList.filter(item => item.active === 'INAC') : [];
            this.verificationByAuthRepresenativeData = this.allEmployeesData?.authRepresentativeList ? this.allEmployeesData.authRepresentativeList.filter(item => item.active === 'INAC'): [];
        }
    }

    isNonInitiated(element: any): boolean {
        return this.nonInitiatedList?this.nonInitiatedList.some(item => item.beneficiaryId === element.beneficiaryId):false;
    }

    getRemoteI9Verifications() {
        const payload = {
            pageNumber: this.pageIndexEverifications + 1,
            recordsPerPage: this.pageSizeEverifications,
            pageSize: this.pageSizeEverifications,
            searchText: this.searchText,
        };
        let companyid  = parseInt(sessionStorage.getItem('companyId'));
        this.i9EverificationService.getRemoteI9Verification(companyid, payload)
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
            if (result) {
                const beneList = result.i9DashBoardList;        
                beneList.forEach(item => {
                item.name = `${item.fname} ${item.mname || ''} ${item.lname}`;
                });
                this.totalRecordCountEverifications = result.totalElementCount;
                this.dataSourceEverifications = new MatTableDataSource(beneList);
            } else {
                this.totalRecordCountEverifications = 0;
                this.dataSourceEverifications = new MatTableDataSource([]);
            }
            //this.getEvaluationRequest(false);
            });
      }

      getUserCredentails(){
        this.eVerifyUserName = '';
        this.eVerifyPassword = '';
        this.i9EverificationService.userCredentials(this.eVerifyLoginPayload?.beneficiaryEmployeeId, this.eVerifyLoginPayload?.companyId, this.eVerifyLoginPayload?.i9AdminId, this.eVerifyLoginPayload?.i9FormId).pipe(takeUntil(this.taskDetailsSubscription$))
        .subscribe((response: ImagilityBaseResponse) => {
          this.eVerifyUserName = response.data.userName;
          this.eVerifyPassword = response.data.password;
        })
       }
      
      termsConditionsFunc(row){
        this.displayModal = true;
    
        let getUSerId = sessionStorage.getItem('userId');
        this.eVerifyLoginPayload = {
          companyId: row.companyId || 0,
          beneficiaryEmployeeId: row.beneficiaryEmployeeId || 0,
          i9FormId: row.formId || 0,
          i9AdminId: Number(getUSerId),
          credential:{
            userName: '',
            passWord:'' 
          }
        };
        this.getUserCredentails();
      }

      downloadUrl(){
        let isProd = '';
        let url=environment.appUrl;
        if(url.includes('https://pl.imagility.co')){
          isProd = url;
        }else if(url.includes('http://3.239.125.215')){
          isProd = url;
        }else if(url.includes('http://18.208.188.1')){
          isProd = url;
        }
        let downloadUrl = '';
        if(this.selectedOS === 'windows'){
          downloadUrl = `${isProd}/application/E-Verify/ImagilityEverify.zip`;
        }
        else{
          downloadUrl = `${isProd}/application/E-Verify/ImagilityEverify.pkg`; 
        }    
        window.open(`${downloadUrl}`, '_blank');
      }

      displayModalFunc(){
        this.displayModal = false;
        this.eVerifyPassword = '';
        this.eVerifyUserName = '';
      }

      postEverifyLogin(){
        this.eVerifyLoginPayload.credential.userName = this.eVerifyUserName;
        this.eVerifyLoginPayload.credential.passWord = this.eVerifyPassword;
        this.i9EverificationService.launchEverify(this.eVerifyLoginPayload)
        .pipe(takeUntil(this.taskDetailsSubscription$))
        .subscribe(result => {
          window.open('imagility-everify://', '_blank');
          this.toastr.success(result.message);
        })
      }
      statusModalFunc(){
        this.statusModal = false;
      }
    
      handleStatusChange(event){
        this.selectedStatus = event.value;
      }
      editEverifiedStatus(row){
        this.companyId= row.companyId;
        this.beneficiaryId = row.beneficiaryEmployeeId;
        this.i9FormId = row.formId;
        this.statusModal = true;
        this.caseNumberUpdate = row.caseNumber
        this.selectedStatus = row.everifyStatus;
      }

      saveVerificationStatus(){
        var caseNumber = this.caseNumberUpdate.toString();
        this.i9EverificationService.saveStatus(this.companyId, this.beneficiaryId, this.i9FormId, caseNumber, this.selectedStatus)
        .pipe(takeUntil(this.observableSubscription$))
        .subscribe((response: ImagilityBaseResponse) => {
            if (response.status == 200) {
                this.getRemoteI9Verifications()
                this.toastr.success(response.message, "Success");
                //this.getUserCredentails();
                this.statusModal = false;
            }
        });
      }

      uploadEverifiedDocument(row){
        let queryParamsObj = {};
        queryParamsObj = {
          companyId: row.companyId || 0,
          beneficiaryEmployeeId: row.beneficiaryEmployeeId|| 0,
          beneficiaryEmployeeFName: row.name || 'Not Available',
          i9FormId: row.formId || 0,
          caseNo : row.caseNumber
        }
        this.router.navigate([`/petitioner-landing/i9-evaluators/everified-document`], { queryParams: queryParamsObj, relativeTo: this.route });
     }

     /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle(event: any) {
    if (event.checked) {
        // Only select rows with 'ACTIVE' status
        this.dataSource.data.forEach(row => {
            if (row.status === 'ACTIVE') {
                this.selection.select(row);
            } else {
                this.selection.deselect(row);
            }
        });
    } else {
        this.selection.clear();
    }
  }

  migrateBeneficiary() {
    const title = 'Onboard Individuals';
    const migrationData = this.selection.selected.map(eachBeneficiary => eachBeneficiary.beneficiaryId);
    this.dialogueInitializer(title, migrationData).afterClosed().subscribe(result => {
      if (result) {
        let companyid = this.selectedCompanyId;
        if (!companyid) {
          companyid = parseInt(sessionStorage.getItem('companyId'));
        }
        this.apiService.migrateOrOnboardEmployees(companyid, migrationData)
        .pipe(takeUntil(this.taskDetailsSubscription$))
        .subscribe((result: any) => {
          if (result) {
            this.toastr.success(result.message, 'Success');
            this.loadBeneficiaryRecordsInit();
          }
        })
      }
    });
  }

  dialogueInitializer(title: string, migrationData: any) {
    const dialogRef = this.dialog.open(MigrationConfirmationModalComponent, {
      width: '600px',
      data: {
        update: { title, migrationData },
        buttons: ['I will do it later', 'Onboard']
      }
    });
    return dialogRef;
  }
  checkIfAllDisabled() {
    return this.dataSource.data.some(e => e.status === 'ACTIVE');
  }

}

@Component({
    selector: 'update-info-dialog',
    templateUrl: 'update-info-dialog.html',
})

export class UpdateInfoDialogComponent implements OnInit {
    communicationForm: FormGroup;
    beneficiaryValue;
    header;
    email;
    userId;
    benName;
    taskDetailsSubscription$ = new Subject();

    constructor(
        public dialogRef: MatDialogRef<UpdateInfoDialogComponent>,
        private apiService: ApiServicesService,
        private toastr: ToastrService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.beneficiaryValue = {
            id: this.data['beneficiary'].beneficiaryId,
            type: this.data['type'],
            email: this.data['beneficiary'].communicationEmailId

        };

        this.benName = this.data['beneficiary'].beneficiaryEmployeeFName +
            this.data['beneficiary'].beneficiaryEmployeeMName + this.data['beneficiary'].beneficiaryEmployeeLName;

        switch (this.beneficiaryValue.type) {
            case 'email':
                this.header = 'Update Communication Email Id';
                break;
            case 'userId':
                this.header = 'Edit User Id';
                break;
            case 'eer':
                this.header = 'Edit Employer Employee Relationship';
                break;
        }
    }

    updateData() {
        let apiUrl = ''; // Define the base API URL

        switch (this.beneficiaryValue.type) {
            case 'email':
                apiUrl = '/i9admin/updateEmail';
                break;
            case 'userId':
                apiUrl = '/i9admin/updateUserId';
                break;
            case 'eer':
                apiUrl = '/i9admin/updateModeOfCreation';
                break;
        }

        const queryParams = {
            beneficiaryId: this.beneficiaryValue.id,
            companyId: sessionStorage.getItem('companyId')
        };

        switch (this.beneficiaryValue.type) {
            case 'email':
                queryParams['email'] = this.beneficiaryValue.email;
                break;
            case 'userId':
                queryParams['userId'] = this.userId;
                break;
            case 'eer':
                queryParams['internal'] = true;
                break;
        }

        this.apiService.updateCommunicationEmailId(queryParams)
            .pipe(takeUntil(this.taskDetailsSubscription$))
            .subscribe(result => {
                if (result.status === 200) {
                    this.toastr.success(result.message, 'Success');
                    this.dialogRef.close(false);
                }
            });
    }

    // Helper function to serialize an object into a query string
    serialize(obj: any): string {
        const queryParams = Object.keys(obj)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
            .join('&');
        return queryParams;
    }


    ngOnInit() {

    }



}
